module.exports = __webpack_public_path__ + "img/_1.abae51eb.png";